import { useRef, useState, useEffect } from 'react';
import Navbar from './sections/navbar/Navbar'
import Header from './sections/header/Header';
import About from './sections/about/About';
// import Services from './sections/myservices/Services';
// import Filiale from "./sections/filiale/Filiale"
import Filialeservices from "./sections/filialeservices/Filialeservices"
import Portfolio from './sections/portfolio/Portfolio';
import FAQs from './sections/faqs/FAQs';
import Contact from './sections/contact/Contact';
import Footer  from './sections/footer/Footer';
import Testimonials from './sections/testimonials/Testimonials';
import FloatingNav from './sections/floating-nav/FloatingNav';
import Modal from "./components/Modal";
import Theme from "./theme/Theme";
import { useThemeContext } from './context/theme-context';


const App = () => {
	const {themeState} = useThemeContext(); 

	const mainRef=useRef();
	const [showFloatingNav, setShowFloatingNav] = useState(true)
	const [siteYPosition, setSiteYPosition] = useState(0)

	const showFloatingNavHandler = ()=>{
		setShowFloatingNav(true);
	}

	const hideFloatingNavHandler = ()=>{
		setShowFloatingNav(false);
	}
 
	// Check if floating nav should be shown or hidden
	const FloatingNavToggleHandler=()=>{
		// check if we scrolled up or down at least 20px
		if(siteYPosition < (mainRef?.current?.getBoundingClientRect().y - 20 ) || siteYPosition > (mainRef?.current?.getBoundingClientRect().y + 20 )){
      showFloatingNavHandler()
		}else{
			hideFloatingNavHandler()
		}
		setSiteYPosition(mainRef?.current?.getBoundingClientRect().y);
	}

useEffect(()=>{
const checkYPosition=setInterval(FloatingNavToggleHandler, 2000);

// cleanup function
return()=>clearInterval(checkYPosition);
// eslint-disable-next-line
},[siteYPosition])

	return (
		<main className={`${themeState.primary} ${themeState.background}`} ref={mainRef}>
			<Navbar/>
			<Header/>
			<About/>
			{/* <Services/> */}
			{/* <Filiale/> */}
			<Filialeservices/>
			<Portfolio/>
			<Testimonials/>
			<FAQs/>
			<Contact/>
			<Footer/>
			<Theme/>
			<Modal/>
			{showFloatingNav && <FloatingNav/>}
		</main>
	)
}

export default App